enum ExcelToCampaignAgentToolName {
  GetCampaignSignals = 'get-campaign-signals',
  CreateCampaignFromExcel = 'create-campaign-from-excel',
  ValidateMappings = 'validate-mappings',
  FindMappingCandidates = 'find-mapping-candidates',
  SanitizeValues = 'sanitize-values',
  ShowExcelImportSummary = 'show-excel-import-summary',
}

enum CampaignBuildingBlockType {
  CreativeId = 'CreativeId',
  CreativeName = 'CreativeName',
  CreativeLandingPage = 'CreativeLandingPage',
  Schedule = 'Schedule',
  Weight = 'Weight',
  Segmentation = 'Segmentation',
}

export {ExcelToCampaignAgentToolName, CampaignBuildingBlockType};
